import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import './style.css';

const Auth = () => {
  return (
    <div className="container-auth">
      <Routes>
        <Route path="/" element={<Navigate to="login" replace />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  );
};

export default Auth;
